export default {
    meta: {
        title: '没有权限',
    },
};
